"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthContextState = void 0;
var Licensing_helper_1 = require("../helpers/Licensing.helper");
var uniq_1 = __importDefault(require("lodash/uniq"));
/**
 * It defines the context state and provides convenience methods to mutate it.
 *
 * @author javier.perez
 */
var AuthContextState = /** @class */ (function () {
    function AuthContextState(state) {
        if (state === void 0) { state = {}; }
        this.impersonation = false;
        Object.assign(this, state);
    }
    Object.defineProperty(AuthContextState.prototype, "isAuthenticated", {
        get: function () {
            return this.user && !!this.user.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthContextState.prototype, "impersonatorName", {
        get: function () {
            var _a, _b;
            if ((_a = this.impersonatorProfile) === null || _a === void 0 ? void 0 : _a.name) {
                var _c = (_b = this.impersonatorProfile) === null || _b === void 0 ? void 0 : _b.name, first = _c.first, last = _c.last;
                return "".concat(first, " ").concat(last);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    AuthContextState.prototype.setUser = function (user) {
        this.user = user;
    };
    AuthContextState.prototype.setLicensing = function (licenses) {
        this.licensingHelper = new Licensing_helper_1.LicensingHelper(licenses);
    };
    AuthContextState.prototype.setAllLicensing = function (licenses) {
        this.unrestrictedLicense = (0, uniq_1.default)(licenses === null || licenses === void 0 ? void 0 : licenses.map(function (_a) {
            var product = _a.product;
            return product.id;
        }));
    };
    AuthContextState.prototype.setSchoolYear = function (schoolYear) {
        this.schoolYear = schoolYear;
    };
    AuthContextState.prototype.setImpersonation = function (impersonation) {
        this.impersonation = impersonation;
    };
    AuthContextState.prototype.setImpersonatorProfile = function (impersonatorProfile) {
        this.impersonatorProfile = impersonatorProfile;
    };
    return AuthContextState;
}());
exports.AuthContextState = AuthContextState;
